import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import Header from 'components/headers/bulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import { SectionError } from 'components/states'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import SettingHeader from './header'
import { ArrowLeftThinIcon } from './icons'
import { settingItems } from './utils'

/**
 * «تنظیمات صندوق» — port of Android's `activity_moneypool_settings.xml`:
 * white page, the fund header, then full-width rows with 16dp padding, a
 * 20dp green icon on the right, a bold 16sp title and a thin grey chevron on
 * the left. Android's «حذف صندوق» (owner only) has no PWA equivalent yet.
 */
export default function Setting() {
    const { id } = useParams()
    const navigate = useNavigate()
    const {
        moneyPoolManagement,
        isLoadingMoneypoolManagement,
        isErrorMoneypoolManagement,
        refetch,
    } = useGetMoneyPoolManagement(id)
    const role = moneyPoolManagement?.poolship?.role
    const loaded = Boolean(moneyPoolManagement)

    useEffect(() => {
        if (loaded) posthog.capture('fund_settings_viewed', { fund_id: id, role })
    }, [loaded, id, role])

    return (
        <div className="min-h-full bg-white">
            <Header title="تنظیمات صندوق" />
            {moneyPoolManagement ? (
                <>
                    <SettingHeader
                        imageId={moneyPoolManagement.image_id}
                        avatar={moneyPoolManagement.custom_avatar}
                        name={moneyPoolManagement.name}
                        interval={moneyPoolManagement.interval}
                        dayOfDue={moneyPoolManagement.day_of_duetion}
                        shareValueAmount={
                            moneyPoolManagement.share_value_amount
                        }
                    />
                    <ul className="pb-4 pt-2">
                        {settingItems.map(
                            ({ key, title, subtext, Icon, route }) => (
                                <li key={key}>
                                    <button
                                        type="button"
                                        className="flex w-full items-start gap-2.5 p-4 text-right active:bg-canvas"
                                        onClick={() => {
                                            posthog.capture(
                                                'fund_setting_item_clicked',
                                                { fund_id: id, item: key }
                                            )
                                            navigate(route + id, {
                                                state: {
                                                    service_package:
                                                        moneyPoolManagement.service_package,
                                                },
                                            })
                                        }}
                                    >
                                        <span className="flex h-6 shrink-0 items-center">
                                            <Icon className="h-5 w-5" />
                                        </span>
                                        <span className="min-w-0 flex-1">
                                            <span className="block text-base font-bold text-black">
                                                {title}
                                            </span>
                                            <span className="mt-0.5 block text-sm leading-6 text-text-secondary">
                                                {subtext}
                                            </span>
                                        </span>
                                        <span className="flex h-6 shrink-0 items-center text-text-muted">
                                            <ArrowLeftThinIcon className="h-3.5 w-3.5" />
                                        </span>
                                    </button>
                                </li>
                            )
                        )}
                    </ul>
                </>
            ) : isErrorMoneypoolManagement && !isLoadingMoneypoolManagement ? (
                <div className="p-4">
                    <SectionError onRetry={refetch} />
                </div>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
